import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { ServiceDetailsViewModel } from 'src/app/view-models/service-details.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-service-details',
  templateUrl: './service-details.component.html',
  styleUrls: ['./service-details.component.scss']
})
export class ServiceDetailsComponent extends BaseComponent<ServiceDetailsViewModel> implements OnInit {

  constructor(commonService: CommonService, logService: LogHandlerService) { 
    super(commonService,logService)
    this.viewModel=new ServiceDetailsViewModel();
  }

  ngOnInit(): void {
  }

}
